<template>
  <div>
    <div class="px-10">
      <v-row no-gutters>
        <v-col cols="4">
          <v-row
            no-gutters
            class="font-16 font-calibri"
          >
            <v-col
              cols="4"
              class="my-auto"
            >
              <span class="font-weight-bold">Join Date</span>
            </v-col>
            <v-col
              cols="1"
              class="my-auto"
            >
              :
            </v-col>
            <v-col
              cols="7"
              class="my-auto"
            >
              <v-skeleton-loader
                v-if="loading"
                type="list-item"
                class="loading-bar"
              />  
              <span v-else>
                {{ joinDate ? $moment(joinDate, 'YYYY-MM-DD').format('D MMM YYYY') :'N/A' }}
                <employee-profile-job-dialog-edit-join-date
                  v-if="$hasPermissionTo(['update employee join date']) && !isMyProfile && !isResigned"
                  :employee-uid="employeeUid"
                  :join-date="joinDate"
                  :confirm-date="confirmDate ? confirmDate : null"
                  @updated="loadJobDetails();$emit('updated')"
                />
              </span> 
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="3">
          <v-row
            no-gutters
            class="font-16 font-calibri"
          >
            <v-col cols="5">
              <span class="font-weight-bold">Confirm Date</span>
            </v-col>
            <v-col cols="1">
              :
            </v-col>
            <v-col cols="6">
              <v-skeleton-loader
                v-if="loading"
                type="list-item"
                class="loading-bar"
              />  
              <span v-else>
                {{ confirmDate ? $moment(confirmDate, 'YYYY-MM-DD').format('D MMM YYYY') :'N/A' }}
                <employee-profile-job-dialog-edit-confirm-date
                  v-if="$hasPermissionTo(['update employee confirm date']) && !isMyProfile && !isResigned"
                  :employee-uid="employeeUid"
                  :confirm-date="confirmDate"
                  :join-date="joinDate"
                  @updated="loadJobDetails();$emit('updated')"
                />
              </span> 
            </v-col>
          </v-row>
        </v-col>
        <v-col
          v-if="$hasPermissionTo(['view job architecture info']) && !isMyProfile"
          cols="4"
        >
          <v-row
            no-gutters
            class="font-16 font-calibri pb-3"
          >
            <v-col cols="2">
              <span class="font-weight-bold">Grade Code</span>
            </v-col>
            <v-col cols="1">
              :
            </v-col>
            <v-col cols="9">
              <v-skeleton-loader
                v-if="loading"
                type="list-item"
                class="loading-bar"
              />  
              <span v-else>
                {{ position && (position || {}).job_grade ? ((position||{}).job_grade||{}).name:'N/A' }}
              </span> 
            </v-col>
          </v-row>
        </v-col>
        <v-col
          v-else
          cols="4"
        >
          <v-row
            no-gutters
            class="font-16 font-calibri pb-3"
          >
            <v-col cols="2">
              <span class="font-weight-bold">Grade</span>
            </v-col>
            <v-col cols="1">
              :
            </v-col>
            <v-col cols="9">
              <v-skeleton-loader
                v-if="loading"
                type="list-item"
                class="loading-bar"
              />  
              <span v-else>
                {{ position && (position || {}).job_grade && ((position || {}).job_grade || {}).job_band ? (((position||{}).job_grade||{}).job_band||{}).value:'N/A' }}
              </span> 
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="1">
          <employee-profile-job-rehire-dialog-edit
            v-if="$hasPermissionTo(['create employee separations']) && !loading && isEmployeeResigned(effectiveDate)"
            :employee-uid="employeeUid"
            :rehire-min-date="effectiveDate ? effectiveDate : ''"
            @updated="loadJobDetails();$emit('updated')"
          />
          <employee-profile-job-separation-dialog-create
            v-if="$hasPermissionTo(['create employee separations']) && !loading && !isEmployeeResigned(effectiveDate) && !isMyProfile"
            :employee-uid="employeeUid"
            :separation-min-date="confirmDate ? confirmDate : joinDate"
            @created="loadJobDetails();$emit('updated')"
          />
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="4">
          <v-row
            no-gutters
            class="font-16 font-calibri pb-3"
          >
            <v-col cols="4">
              <span class="font-weight-bold">Department</span>
            </v-col>
            <v-col cols="1">
              :
            </v-col>
            <v-col cols="7">
              <v-skeleton-loader
                v-if="loading"
                type="list-item"
                class="loading-bar"
              />  
              <span v-else>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{ department ? (department||{}).name:'N/A' }} </span>
                  
                  </template>
                  <span class="font-weight-bold">Section: {{ section? (section||{}).name :'N/A' }}</span>
                </v-tooltip>
                
                <employee-profile-job-dialog-list-departments
                  v-if="!loading"
                  :employee-uid="employeeUid"
                  :join-date="joinDate"
                  :is-resigned="isResigned"
                  @created="loadJobDetails();$emit('updated')"
                />

                <employee-profile-job-dialog-edit-department
                  v-if="$hasPermissionTo(['update employee department']) && !isMyProfile && !isResigned"
                  :employee-uid="employeeUid"
                  :department="department"
                  :section="section"
                  @updated="loadJobDetails();$emit('updated')"
                />
              </span> 
            </v-col>
          </v-row>
        </v-col> 
        <v-col cols="3">
          <v-row
            no-gutters
            class="font-16 font-calibri"
          >
            <v-col cols="5">
              <span class="font-weight-bold">Year of Service</span>
            </v-col>
            <v-col cols="1">
              :
            </v-col>
            <v-col cols="6">
              <v-skeleton-loader
                v-if="loading"
                type="list-item"
                class="loading-bar"
              />  
              <span v-else>
                {{ yearOfService ? (yearOfService+' year(s)' ):'N/A' }}
              </span> 
            </v-col>
          </v-row>
        </v-col>
        <v-col
          v-if="$hasPermissionTo(['view job architecture info']) && !isMyProfile"
          cols="4"
        >
          <v-row
            no-gutters
            class="font-16 font-calibri"
          >
            <v-col cols="2">
              <span class="font-weight-bold">Group</span>
            </v-col>
            <v-col cols="1">
              :
            </v-col>
            <v-col cols="9">
              <v-skeleton-loader
                v-if="loading"
                type="list-item"
                class="loading-bar"
              />  
              <span v-else>
                {{ position && (position || {}).job_grade && ((position || {}).job_grade || {}).job_group ? (((position||{}).job_grade||{}).job_group||{}).name:'N/A' }}
              </span> 
            </v-col>
          </v-row>
        </v-col>
        <v-col
          v-else
          cols="4"
        >
          <v-row
            no-gutters
            class="font-16 font-calibri"
          >
            <v-col
              cols="2"
            >
              <span class="font-weight-bold">Position</span>
            </v-col>
            <v-col cols="1">
              :
            </v-col>
            <v-col
              cols="9"
              class="ml-n8"
            >
              <v-skeleton-loader
                v-if="loading"
                type="list-item"
                class="loading-bar"
              />  
              <span 
                v-else
                class="ml-8"
              >
                {{ position ? (position||{}).name:'N/A' }}
                
                <employee-profile-job-dialog-list-positions
                  v-if="!loading"
                  :employee-uid="employeeUid"
                  :join-date="joinDate"
                  :is-resigned="isResigned"
                  @created="loadJobDetails();$emit('updated')"
                />

                <employee-profile-job-dialog-edit-position 
                  v-if="$hasPermissionTo(['update employee position']) && !isMyProfile && !isResigned"
                  :employee-uid="employeeUid"
                  :position="position"
                  @updated="loadJobDetails();$emit('updated')"
                />
              </span> 
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="1" />
      </v-row>

      <v-row no-gutters>
        <v-col cols="4">
          <v-row
            no-gutters
            class="font-16 font-calibri pb-3"
          >
            <v-col cols="4">
              <span class="font-weight-bold">Base Location</span>
            </v-col>
            <v-col cols="1">
              :
            </v-col>
            <v-col
              cols="7"
            >
              <v-skeleton-loader
                v-if="loading"
                type="list-item"
                class="loading-bar"
              />  
              <span v-else>
                {{ baseLocation ? baseLocation:'N/A' }}
                <employee-profile-job-dialog-edit-base-location
                  v-if="$hasPermissionTo(['update employee base location']) && !isMyProfile && !isResigned"
                  :employee-uid="employeeUid"
                  :state="state"
                  :city="city"
                  @updated="loadJobDetails()"
                />
              </span> 
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="3">
          <v-row
            no-gutters
            class="font-16 font-calibri"
          >
            <v-col cols="5">
              <span class="font-weight-bold">Last Working Date</span>
            </v-col>
            <v-col cols="1">
              :
            </v-col>
            <v-col cols="6">
              <v-skeleton-loader
                v-if="loading"
                type="list-item"
                class="loading-bar"
              />  
              <span v-else>
                {{ lastWorkingDate ? $moment(lastWorkingDate, 'YYYY-MM-DD').format('D MMM YYYY'):'N/A' }}
              </span> 
            </v-col>
          </v-row>
        </v-col>
        <v-col
          v-if="$hasPermissionTo(['view job architecture info']) && !isMyProfile"
          cols="4"
        >
          <v-row
            no-gutters
            class="font-16 font-calibri"
          >
            <v-col cols="2">
              <span class="font-weight-bold">Category</span>
            </v-col>
            <v-col cols="1">
              :
            </v-col>
            <v-col cols="9">
              <v-skeleton-loader
                v-if="loading"
                type="list-item"
                class="loading-bar"
              />  
              <span v-else>
                {{ position && (position || {}).job_grade && ((position || {}).job_grade || {}).job_category ? (((position||{}).job_grade||{}).job_category||{}).name:'N/A' }}
              </span> 
            </v-col>
          </v-row>
        </v-col>
        <v-col
          v-else
          cols="4"
        />
        <v-col cols="1">
          <employee-profile-job-rejoin-dialog-edit
            v-if="$hasPermissionTo(['create employee separations']) && !loading && isEmployeeResigned(effectiveDate)"
            :employee-uid="employeeUid"
            :rejoin-min-date="effectiveDate ? effectiveDate : ''"
            @updated="loadJobDetails();$emit('updated')"
          />
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="4">
          <v-row
            no-gutters
            class="font-16 font-calibri pb-3"
          >
            <v-col cols="4">
              <span class="font-weight-bold">Probation Due Date</span>
            </v-col>
            <v-col cols="1">
              :
            </v-col>
            <v-col cols="6">
              <v-skeleton-loader
                v-if="loading"
                type="list-item"
                class="loading-bar"
              />  
              <span v-else>
                {{ calculateProbationDueDate(joinDate, ((position || {}).job_grade || {}).job_band) }}
                <employee-profile-job-dialog-edit-probation-due-date
                  v-if="$hasPermissionTo(['update employee join date']) && !isMyProfile && !isResigned && currentNormalHireProbation"
                  :employee-uid="employeeUid"
                  :probation-due-date="currentNormalHireProbation.end_date"
                  @updated="loadJobDetails()"
                />
              </span> 
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="3">
          <v-row
            no-gutters
            class="font-16 font-calibri pb-3"
          >
            <v-col cols="5">
              <span class="font-weight-bold">Effective Date</span>
            </v-col>
            <v-col cols="1">
              :
            </v-col>
            <v-col cols="6">
              <v-skeleton-loader
                v-if="loading"
                type="list-item"
                class="loading-bar"
              />  
              <span v-else>
                {{ effectiveDate ? $moment(effectiveDate, 'YYYY-MM-DD').format('D MMM YYYY'):'N/A' }}
    
                <employee-profile-job-separation-dialog-list
                  v-if="$hasPermissionTo(['create employee separations']) && !loading && !isMyProfile"
                  :employee-uid="employeeUid"
                  :separation-min-date="confirmDate ? confirmDate : joinDate"
                  @updated="loadJobDetails();$emit('updated')"
                />
              </span> 
            </v-col>
          </v-row>
        </v-col>
        <v-col
          v-if="$hasPermissionTo(['view job architecture info']) && !isMyProfile"
          cols="4"
        >
          <v-row
            no-gutters
            class="font-16 font-calibri"
          >
            <v-col cols="2">
              <span class="font-weight-bold">Grade</span>
            </v-col>
            <v-col cols="1">
              :
            </v-col>
            <v-col cols="9">
              <v-skeleton-loader
                v-if="loading"
                type="list-item"
                class="loading-bar"
              />  
              <span v-else>
                {{ position && (position || {}).job_grade && ((position || {}).job_grade || {}).job_band ? (((position||{}).job_grade||{}).job_band||{}).value:'N/A' }}
              </span> 
            </v-col>
          </v-row>
        </v-col>
        <v-col
          v-else
          cols="4"
        />
        <v-col cols="1" />
      </v-row>

      <v-row
        no-gutters
        class="font-16 font-calibri pb-3"
      >
        <v-col
          cols="7"
        />
        
        <v-col
          v-if="$hasPermissionTo(['view job architecture info']) && !isMyProfile"
          cols="4"
        >
          <v-row
            no-gutters
            class="font-16 font-calibri"
          >
            <v-col
              cols="2"
            >
              <span class="font-weight-bold">Position</span>
            </v-col>
            <v-col cols="1">
              :
            </v-col>
            <v-col
              cols="9"
              class="ml-n8"
            >
              <v-skeleton-loader
                v-if="loading"
                type="list-item"
                class="loading-bar"
              />  
              <span 
                v-else
                class="ml-8"
              >
                {{ position ? (position||{}).name:'N/A' }}
                
                <employee-profile-job-dialog-list-positions
                  v-if="!loading"
                  :employee-uid="employeeUid"
                  :join-date="joinDate"
                  :is-resigned="isResigned"
                  @created="loadJobDetails();$emit('updated')"
                />

                <employee-profile-job-dialog-edit-position 
                  v-if="$hasPermissionTo(['update employee position']) && !isMyProfile && !isResigned"
                  :employee-uid="employeeUid"
                  :position="position"
                  @updated="loadJobDetails();$emit('updated')"
                />
              </span> 
            </v-col>
          </v-row>
        </v-col>
        <v-col
          v-else
          cols="4"
        />
      </v-row>

      <v-divider />

      <v-row
        no-gutters
        class="pt-5"
      >
        <v-col
          cols="5"
          class="pt-0"
        >
          <span class="font-weight-bold font-16 font-calibri">Workdays:</span>
          <employee-profile-job-dialog-edit-workday
            v-if="$hasPermissionTo(['update employee workdays']) && !loading && !isMyProfile && !isResigned"
            :employee-uid="employeeUid"
            @updated="loadJobDetails"
          />
          <v-data-table
            :headers="headers"
            :items="workDays"
            disable-pagination
            hide-default-footer
            dense
            class="mt-5"
            :style="`max-width:${width}px;border:1px solid rgba(0,0,0,.12)`"
          >
            <template v-slot:item.name="{ item }">
              <div>
                <v-skeleton-loader
                  v-if="loading"
                  type="list-item"
                />  
                <span v-else>
                  {{ item.name }}
                </span>
              </div>
            </template>

            <template v-slot:item.work_session="{ item }">
              <div>
                <v-skeleton-loader
                  v-if="loading"
                  type="list-item"
                />  
                <span v-else>
                  {{ $moment(item.work_session.start_time,'hh:mm').format('hh:mm A') }} - {{ $moment(item.work_session.end_time,'hh:mm').format('hh:mm A') }}
                </span>
              </div>
            </template>

            <template v-slot:item.leave_session="{ item }">
              <div>
                <v-skeleton-loader
                  v-if="loading"
                  type="list-item"
                />  
                <span v-else>
                  {{ item.leave_session.name }}
                </span>
              </div>
            </template>
          </v-data-table>
        </v-col>
        
        <v-col
          cols="7"
          class="mt-n4"
        >
          <span class="font-weight-bold font-16 font-calibri py-0">Duty Roster</span>
          <v-btn
            v-if="!showCalendar"
            fab
            text
            color="grey darken-2"
            @click="showCalendar = true"
          >
            <v-icon>
              mdi-calendar-plus
            </v-icon>
          </v-btn>
          <v-btn
            v-if="showCalendar"
            fab
            text
            color="grey darken-2"
            @click="showCalendar = false"
          >
            <v-icon>
              mdi-calendar-minus
            </v-icon>
          </v-btn>
          <v-btn
            v-if="showCalendar"
            fab
            text
            small
            color="grey darken-2"
            @click="prev"
          >
            <v-icon small>
              mdi-chevron-left
            </v-icon>
          </v-btn>
          <span v-if="showCalendar"> {{ calendarTitle }} </span>
          <v-btn
            v-if="showCalendar"
            fab
            text
            small
            color="grey darken-2"
            @click="next"
          >
            <v-icon small>
              mdi-chevron-right
            </v-icon>
          </v-btn>
          <v-sheet 
            v-if="showCalendar"
            max-height="400" 
            width="100%"
            border-sm
            elevation="2"
          >
            <v-row 
              v-if="calendarLoading"
              no-gutters
            >
              <v-progress-linear
                indeterminate
                color="primary"
              />
            </v-row>
            <v-row 
              v-else
              no-gutters
            >
              <v-calendar
                ref="calendar"
                v-model="today"
                color="primary"
                :events="events"
                :event-color="getEventColor"
                type="month"
                @click:date="onClickDate"
                @change="updateTitle"
              >
                <template v-slot:event="{ event }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }"> 
                      <div 
                        class="pl-1 py-0 font-calibri"
                        v-bind="attrs"
                        v-on="on"
                        @click.stop="openEditForm(event)"
                      >
                        <span>{{ event.shiftTime }}</span>
                      </div>
                    </template>
                    <div v-if="event.shiftCode">
                      Shift code: 
                      <span class="font-weight-bold">
                        {{ event.shiftCode }}
                      </span>
                    </div>
                    <div>
                      Remark: 
                      <span 
                        v-if="event.name"
                        v-html="event.name.replace(/\n/g, '</br>')" 
                      />
                      <span v-else>-</span>
                    </div>
                  </v-tooltip>
                </template>
              </v-calendar>
            </v-row>
          </v-sheet>
        </v-col>
        <v-col cols="1" />
      </v-row>

      <v-divider class="mt-5" />

      <v-row
        v-if="!loading"
        no-gutters
        class="font-16 font-calibri"
      >
        <v-col
          cols="4"
          class="mt-5 font-16 font-calibri"
        >
          <span class="font-weight-bold">Attendance User ID: </span>
          <span>{{ (user || {}).user_id ? (user || {}).user_id : ' N/A ' }}</span>
          <employee-profile-job-dialog-edit-user-id
            v-if="$hasPermissionTo(['update employees']) && !loading && !isMyProfile && !isResigned"
            :user-uid="(user || {}).user_uid"
            :user-id="(user || {}).user_id ? (user || {}).user_id : 0"
            @updated="loadJobDetails()"
          />
        </v-col>
        <v-col
          cols="8"
          class="pl-2 mt-5 font-16 font-calibri font-weight-bold"
        >
          <span>Require Check Location When Clock In/Out: </span>
          <span
            :style="requireLocationChecking ? 'color:green' : 'color:red'"
          >
            {{ requireLocationChecking ? 'YES' : 'No' }}
          </span>
          <employee-profile-job-dialog-edit-require-location-checking
            v-if="$hasPermissionTo(['update employees']) && !loading && !isMyProfile && !isResigned"
            :employee-uid="employeeUid"
            :require-location-checking="requireLocationChecking"
            @updated="loadJobDetails()"
          />
          <employee-profile-job-office-location-dialog-list
            v-if="!loading"
            :employee-uid="employeeUid"
            :is-resigned="isResigned"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="4"
          class="font-16 font-calibri"
        >
          <span class="font-weight-bold">Superior:</span> 
          <employee-profile-job-dialog-edit-superior
            v-if="$hasPermissionTo(['update employee reporting line']) && !loading && !isMyProfile && !isResigned"
            :employee-uid="employeeUid"
            @updated="loadJobDetails(); $emit('updated')"
          />

          <v-row>
            <v-col cols="12">
              <v-card v-if="reportTo.employee_uid !== undefined">
                <v-skeleton-loader
                  v-if="loading"
                  style="height:71px"
                  type="image"
                />
                <v-list-item v-else>
                  <v-list-item-avatar 
                    class="mr-4" 
                    size="55"
                  >
                    <img 
                      :src="superior.thumbnail_url" 
                      onerror="this.src='img/thumbnail.jpg'" 
                      alt="Superior Image"
                    >
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="px-0">
                      {{ superiorPerson.name }}
                    </v-list-item-title>
                    <v-list-item-subtitle> {{ isSuperiorResigned(superior.end_date) ? 'Resigned' : (superior.is_active ? 'Active' : 'On Leave') }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-card>

              <span v-else>No superior yet</span>
            </v-col>
          </v-row>
        </v-col>

        <v-col
          cols="8"
          class="font-16 font-calibri"
        >
          <span class="font-weight-bold">Subordinate(s):</span>
          <employee-profile-job-dialog-edit-subordinates
            v-if="$hasPermissionTo(['update employee reporting line']) && !loading && !isMyProfile && !isResigned"
            :employee-uid="employeeUid"
            @updated="loadJobDetails()"
          />
          <v-row>
            <v-col
              v-for="subordinate in subordinates"
              :key="subordinate.employee_uid"
              cols="6"
            >
              <v-card>
                <v-skeleton-loader
                  v-if="loading"
                  style="height:71px"
                  type="image"
                />
                <v-list-item v-else>
                  <v-list-item-avatar 
                    class="mr-4" 
                    size="55"
                  >
                    <img 
                      :src="subordinate.employee.thumbnail_url" 
                      onerror="this.src='img/thumbnail.jpg'" 
                      alt="Subordinate Image"
                    >
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="px-0">
                      {{ subordinate.employee.person.name }}
                    </v-list-item-title>
                    <v-list-item-subtitle> {{ subordinate.employee.is_active ? 'Active' : 'On Leave' }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item> 
              </v-card>
            </v-col>

            <v-col
              v-if="noOfSubordinates < 1"
              cols="12"
            >
              <span>No subordinates yet</span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    
    <v-dialog
      v-model="showForm"
      persistent
      max-width="500px"
    >
      <material-card
        :offset="10"
        :full-width="true"
        :loading="loading"
        color="hrissecondary"
        title="Duty Roster"
        :text="'Create Employee Duty Roster Record for ' + selectedDate"
        class="mb-0"
      >
        <v-row 
          no-gutters
          class="mt-5"
        >
          <v-col 
            cols="12"
            class="py-0"
          >
            <v-switch
              v-model="useShift"
              label="Use shift from work session type"
              @change="selectedShift = null; startTime = '00:00:00'; endTime = '00:00:00'"
            />
          </v-col>
          <v-col
            v-if="useShift"
            cols="12"
            class="py-0"
          >
            <v-autocomplete 
              v-model="selectedShift"
              v-validate="useShift ? 'required' : ''"
              :error-messages="errors.collect('selectedShift')"    
              data-vv-name="selectedShift"
              data-vv-as="shift"
              placeholder="Select shift"
              :items="workSessionShiftCodes"
              item-text="code"
              item-value="id"
              return-object
              label="Shift Code"
              hide-selected
              autofocus
              outlined
              class="label-position"
              @change="setValues(false)"
            />
          </v-col>
          <v-col 
            cols="6"
            class="py-0 pr-2"
          >
            <v-text-field
              v-model="startTime"
              v-validate="'required|time_before_or_equal:' + endTime"
              :error-messages="errors.collect('startTime')"    
              data-vv-name="startTime"
              data-vv-as="start time"
              :readonly="useShift"
              outlined
              label="Start Time"
              type="time"
            />
          </v-col>
          <v-col 
            cols="6"
            class="py-0 pl-2"
          >
            <v-text-field
              v-model="endTime"
              v-validate="'required|time_after_or_equal:' + startTime"
              :error-messages="errors.collect('endTime')"    
              data-vv-name="endTime"
              data-vv-as="end time"
              :readonly="useShift"
              outlined
              label="End Time"
              type="time"
            />
          </v-col>
          <v-col
            cols="12"
          >
            <v-textarea
              v-model="remark"
              :rows="2"
              outlined
              label="Remark"
            />
          </v-col>
        </v-row>

        <v-card-actions v-if="showForm && !loading">
          <v-spacer />
          <v-btn
            :disabled="progressing"
            text
            class="px-10"
            @click="showForm = false; resetForm()"
          >
            Cancel
          </v-btn>
          <v-btn
            :loading="progressing"
            color="hrissecondary"    
            class="white--text px-10"      
            @click="submitForm"
          >
            Save
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    
    <v-dialog
      v-if="selectedEvent"
      v-model="showEventDialog"
      persistent
      max-width="500px"
    >
      <material-card
        :offset="10"
        :full-width="true"
        :loading="loading"
        color="hrissecondary"
        :title="'Duty Roster (' + selectedEvent.start + ')'"
        :text="'Edit / Delete Employee Duty Roster Record for ' + selectedEvent.start"
        class="mb-0"
      >
        <v-row 
          no-gutters
          class="mt-5"
        >
          <v-col 
            cols="12"
            class="py-0"
          >
            <v-switch
              v-model="useShift"
              label="Use shift from work session type"
              :disabled="!$hasPermissionTo(['update duty rosters'])"
              @change="selectedShift = null; localEvent.start_time = '00:00:00'; localEvent.end_time = '00:00:00'"
            />
          </v-col>
          <v-col
            v-if="useShift"
            cols="12"
            class="py-0"
          >
            <v-autocomplete 
              v-model="selectedShift"
              v-validate="useShift ? 'required' : ''"
              :error-messages="errors.collect('selectedShift')"    
              data-vv-name="selectedShift"
              data-vv-as="shift"
              placeholder="Select shift"
              :items="workSessionShiftCodes"
              item-text="code"
              item-value="id"
              return-object
              label="Shift Code"
              hide-selected
              autofocus
              outlined
              class="label-position"
              :disabled="!$hasPermissionTo(['update duty rosters'])"
              @change="setValues(true)"
            />
          </v-col>
          <v-col 
            cols="6"
            class="py-0 pr-2"
          >
            <v-text-field
              v-model="localEvent.start_time"
              v-validate="'required|time_before_or_equal:' + localEvent.end_time"
              :error-messages="errors.collect('startTime')"    
              :disabled="useShift || !$hasPermissionTo(['update duty rosters'])"
              data-vv-name="startTime"
              data-vv-as="start time"
              :readonly="useShift"
              outlined
              label="Start Time"
              type="time"
              class="label-position"
            />
          </v-col>
          <v-col 
            cols="6"
            class="py-0 pl-2"
          >
            <v-text-field
              v-model="localEvent.end_time"
              v-validate="'required|time_after_or_equal:' + localEvent.start_time"
              :error-messages="errors.collect('endTime')"    
              :disabled="useShift || !$hasPermissionTo(['update duty rosters'])"
              data-vv-name="endTime"
              data-vv-as="end time"
              :readonly="useShift"
              outlined
              label="End Time"
              type="time"
              class="label-position"
            />
          </v-col>
          <v-col
            cols="12"
          >
            <v-textarea
              v-model="localEvent.remark"
              :rows="2"
              outlined
              label="Remark"
              class="label-position"
              :disabled="!$hasPermissionTo(['update duty rosters'])"
            />
          </v-col>
        </v-row>
    
        <v-dialog
          v-model="deleteConfirmationDialog"
          max-width="400px"
        >
          <v-card>
            <v-card-title class="headline">
              Delete Confirmation
            </v-card-title>
            <v-card-text>
              Are you sure to delete this duty roster?
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn
                :disabled="deleteEventProgressing"
                text
                @click="deleteConfirmationDialog = false"
              >
                No
              </v-btn>
              <v-btn
                :loading="deleteEventProgressing"
                color="hrissecondary"
                class="white--text"
                @click="deleteEventForm"
              >
                Yes
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-card-actions v-if="showEventDialog">
          <v-spacer />
          <v-btn
            :disabled="editEventProgressing || deleteEventProgressing"
            text
            class="px-5"
            @click="showEventDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            v-if="$hasPermissionTo(['update duty rosters'])"
            :loading="editEventProgressing"
            :disabled="deleteEventProgressing"
            color="hrissecondary"    
            class="white--text px-5"      
            @click="editEventForm"
          >
            Update
          </v-btn>
          <v-btn
            v-if="$hasPermissionTo(['delete duty rosters'])"
            :loading="deleteEventProgressing"
            :disabled="editEventProgressing"
            color="error"    
            class="white--text px-5"      
            @click="deleteConfirmationDialog = true"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    components: {
      EmployeeProfileJobDialogEditJoinDate: () => import('@/components/hris/employee/profile/job/DialogEditJoinDate'),
      EmployeeProfileJobDialogEditDepartment: () => import('@/components/hris/employee/profile/job/DialogEditDepartment'),
      EmployeeProfileJobDialogEditConfirmDate: () => import('@/components/hris/employee/profile/job/DialogEditConfirmDate'),
      EmployeeProfileJobDialogEditPosition: () => import('@/components/hris/employee/profile/job/DialogEditPosition'),
      EmployeeProfileJobDialogEditBaseLocation: () => import('@/components/hris/employee/profile/job/DialogEditBaseLocation'),
      EmployeeProfileJobSeparationDialogCreate: () => import('@/components/hris/employee/profile/job/separation/DialogCreate'),
      EmployeeProfileJobDialogEditWorkday: () => import('@/components/hris/employee/profile/job/DialogEditWorkday'),
      EmployeeProfileJobDialogEditSuperior: () => import('@/components/hris/employee/profile/job/DialogEditSuperior'),
      EmployeeProfileJobDialogEditSubordinates: () => import('@/components/hris/employee/profile/job/DialogEditSubordinates'),
      EmployeeProfileJobSeparationDialogList: () => import('@/components/hris/employee/profile/job/separation/DialogList'),
      EmployeeProfileJobRehireDialogEdit: () => import('@/components/hris/employee/profile/job/rehire/DialogEdit'),
      EmployeeProfileJobRejoinDialogEdit: () => import('@/components/hris/employee/profile/job/rejoin/DialogEdit'),
      EmployeeProfileJobDialogEditUserId: () => import('@/components/hris/employee/profile/job/DialogEditUserId'),
      EmployeeProfileJobDialogEditRequireLocationChecking: () => import('@/components/hris/employee/profile/job/DialogEditRequireLocationChecking'),
      EmployeeProfileJobDialogEditProbationDueDate: () => import('@/components/hris/employee/profile/job/DialogEditProbationDueDate'),
      EmployeeProfileJobDialogListDepartments: () => import('@/components/hris/employee/profile/job/DialogListDepartments'),
      EmployeeProfileJobDialogListPositions: () => import('@/components/hris/employee/profile/job/DialogListPositions'),
      EmployeeProfileJobOfficeLocationDialogList: () => import('@/components/hris/employee/profile/job/office-location/DialogList'),
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      isResigned: {
        type: Boolean,
        required: true,
      },
    },
    data () {
      return {
        joinDate: null,
        confirmDate: null,
        yearOfService: null,
        department: null,
        position: null,
        baseLocation: null,
        lastWorkingDate: null,
        effectiveDate: null,
        basicSalary: null,
        loading: false,
        section: null,
        state: null,
        city: null,
        workDays: [],
        headings: [
          {
            text: 'Workday', 
            sortable: false, 
            value: 'name',
            divider: true,
            width: 128,
          },
          {
            text: 'Session',
            sortable: false,
            value: 'work_session',
            divider: true,
            width: 197,
          },
        ],
        reportTo: {},
        user: {},
        subordinates: [],
        probationData: [],
        currentNormalHireProbation: {},
        showPositionRecord: false,
        requireLocationChecking: false,
        positionRecords: [],
        positionHistoryHeadings: [
          {
            text: 'Position', 
            sortable: false, 
            value: 'position.name',
            divider: true,
            width: 220,
          },
          {
            text: 'Start Date',
            sortable: false,
            value: 'start_date',
            divider: true,
            width: 120,
            align: 'center',
          },  
          {
            text: 'End Date', 
            sortable: false, 
            value: 'end_date',
            divider: true,
            width: 120,
            align: 'center',
          },                   
        ],
        today: new Date().toISOString().slice(0, 10),
        showCalendar: false,
        showForm: false,
        selectedDate: null,
        progressing: false,
        events: [],
        currentMonth: this.$moment().format('YYYY-MM'),
        calendarTitle: '',
        startTime: '00:00:00',
        endTime: '00:00:00',
        remark: null,
        calendarLoading: false,
        showEventDialog: false,
        selectedEvent: null,
        localEvent: null,
        editEventProgressing: false,
        deleteEventProgressing: false,
        deleteConfirmationDialog: false,
        useShift: true,
        workSessionShiftCodes: [],
        selectedShift: null,
      }
    },
    computed: {
      ...mapState({ isCurrentUser: 'isMyProfile' }),
      isMyProfile () {
        return this.$store.state.isMyProfile
      },
      width () {
        if (this.headers.length < 3) {
          return 328
        }
        return 500
      },
      headers () {
        let originalTab = [...this.headings]
        if (this.$hasPermissionTo(['update employee workdays'])) {
          originalTab.splice(originalTab.length, 0, {
            text: 'Leave Session',
            sortable: false,
            align: 'center',
            value: 'leave_session',
            width: 173,
          })
        }

        return originalTab
      },
      positionHistoryHeaders () {
        let originalTab = [...this.positionHistoryHeadings]
        if (this.$hasPermissionTo(['update employee position']) && !this.isMyProfile && !this.isResigned) {
          originalTab.splice(originalTab.length, 0, {
            text: '',
            sortable: false,
            align: 'center',
            value: 'action',
            width: 50,
          })
        }

        return originalTab
      },
      superior () {
        return (this.reportTo || {})
      },
      superiorPerson () {
        return (this.reportTo.person || {})
      },
      noOfSubordinates () {
        return this.subordinates.length
      },
      eventDates () {
        return this.events.map(e => this.$moment(e.start).format('YYYY-MM-DD'))
      },
    },
    watch: {
      employeeUid: {
        immediate: true,
        handler (newVal, oldVal) {
          this.$resetData()
          this.showCalendar = false
          if (!_.isEmpty(newVal)) {
            this.loadJobDetails()
            this.loadDutyRosters()
          }
        },
      },
      showCalendar (val) {
        if (val) {
          this.$nextTick(() => {
            this.updateTitle()
          })
        }
        
        function toMinutes (time) {
          if (!time) return null
          const [h, m] = time.split(':')
          return (parseInt(h) * 60) + parseInt(m)
        }

        this.$validator.extend('time_before_or_equal', {
          getMessage (field, args) {
            return `The ${field} must be earlier than end time.`
          },
          validate (value, args) {
            const [otherValue] = args
            return toMinutes(value) <= toMinutes(otherValue)
          },
        })

        this.$validator.extend('time_after_or_equal', {
          getMessage (field, args) {
            return `The ${field} must be later than start time.`
          },
          validate (value, args) {
            const [otherValue] = args
            return toMinutes(value) >= toMinutes(otherValue)
          },
        })
      },
    },
    methods: {
      resetForm () {
        this.startTime = '00:00:00'
        this.endTime = '00:00:00'
        this.remark = null
        this.useShift = true
        this.selectedShift = null
      },
      loadWorkSessionShiftCodes (id) {
        this.workSessionShiftCodes = []

        this.$api.shiftCodes().list(id)
          .then(res => {
            this.workSessionShiftCodes = _.orderBy(res.data, ['start_time'], ['asc'])
          })
      },
      setValues (isEdit) {
        if (!isEdit) {
          this.startTime = this.selectedShift.start_time
          this.endTime = this.selectedShift.end_time
        } else {
          this.localEvent.work_session_shift_code_id = this.selectedShift.id
          this.localEvent.start_time = this.selectedShift.start_time
          this.localEvent.end_time = this.selectedShift.end_time
        }
      },
      updateTitle () {
        if (this.$refs.calendar && this.$refs.calendar.value) {
          const newMonth = this.$moment(this.$refs.calendar.value).format('YYYY-MM')
          if (!this.calendarTitle || newMonth !== this.currentMonth) {
            this.currentMonth = newMonth
            this.calendarTitle = this.$moment(this.$refs.calendar.value).format('MMM YYYY')
            this.loadDutyRosters()
          }
        }
      },
      prev () {
        this.$refs.calendar.prev()
      },
      next () {
        this.$refs.calendar.next()
      },
      loadDutyRosters () {
        this.calendarLoading = true
        const date = this.$refs.calendar && this.$refs.calendar.value ? this.$refs.calendar.value : this.today

        this.$api.dutyRosters().list(this.employeeUid, { date: date })
          .then(res => {
            this.events = _.orderBy(res.data.map(roster => {
              return {
                id: roster.id,
                name: roster.remark,
                start: roster.date,
                startTime: roster.start_time,
                endTime: roster.end_time,
                shiftCodeId: roster.work_session_shift_code_id,
                shiftCode: roster.work_session_shift_code ? roster.work_session_shift_code.code : null,
                remark: roster.remark,
                color: roster.start_time === roster.end_time ? 'red' : 'blue',
                shiftTime: (roster.start_time === roster.end_time) ? 'OFF DAY' : this.$moment(roster.start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(roster.end_time, 'hh:mm').format('hh:mm A'),
              }
            }), ['start'], ['asc'])

            this.calendarLoading = false
          })
      },
      loadJobDetails () {
        this.loading = true

        Promise.all([
          this.$api.jobDetails().list(this.employeeUid),
          this.$api.hrisEmployeeWorkDays().list(this.employeeUid),
          this.$api.hrisReportTo().show(this.employeeUid),
          this.$api.hrisSubordinates().list(this.employeeUid),
          this.$api.hrisEmployeePositions().list(this.employeeUid),
        ])
          .then(([jobDetails, workDay, reportTo, subordinates, positionRecords]) => {
            this.joinDate = jobDetails.data.joined_date
            this.confirmDate = jobDetails.data.confirmed_date
            this.requireLocationChecking = jobDetails.data.require_location_checking
            this.department = jobDetails.data.department
            this.section = jobDetails.data.section
            this.lastWorkingDate = jobDetails.data.last_working_date
            this.effectiveDate = jobDetails.data.end_date
            this.position = (jobDetails.data.current_position || {}).position
            this.probationData = jobDetails.data.employee_probations
            this.user = (jobDetails.data.person || {}).user
            this.positionRecords = _.orderBy(positionRecords.data, ['created_at'], ['desc'])

            this.positionRecords = this.positionRecords.map((item, index) => ({
              index: index,
              ...item,
            }))

            const normalHireProbations = this.probationData.filter(probation => { 
              return probation.type === 'normal hire' && probation.start_date === this.joinDate
            })

            this.currentNormalHireProbation = normalHireProbations[0]

            let noOfDaysInCurrentYear = this.$moment().endOf('year').diff(this.$moment().startOf('year'), 'days') + 1 // includes day 1
            this.yearOfService = ((this.$moment().diff(this.$moment(jobDetails.data.joined_date), 'days') + 1) / noOfDaysInCurrentYear).toFixed(2)
            if (jobDetails.data.end_date) {
              this.yearOfService = ((this.$moment(jobDetails.data.end_date).diff(this.$moment(jobDetails.data.joined_date), 'days') + 1) / noOfDaysInCurrentYear).toFixed(2)
            }
            this.baseLocation = ((jobDetails.data || {}).city || {}).name + ', ' + (((jobDetails.data || {}).city || {}).state || {}).name

            this.city = (jobDetails.data || {}).city
            this.state = ((jobDetails.data || {}).city || {}).state
            
            this.workDays = _.orderBy(workDay.data, ['day'], ['asc'])

            this.workDays.map(item => {
              if (item.leave_session.name === 'None') {
                item.leave_session.name = 'No Restriction'
              } else if (item.leave_session.name === 'A.M') {
                item.leave_session.name = 'A.M only'
              } else if (item.leave_session.name === 'P.M') {
                item.leave_session.name = 'P.M only'
              } else {
                item.leave_session.name = 'Full Day'
              }
            })

            this.loadWorkSessionShiftCodes(this.workDays[0].work_session.work_session_type_id)

            this.setNamesForDay()

            // temp solution to let HR able to clean up data
            this.reportTo = reportTo.data || {}
            /// ////////////////////////////////////////////////

            this.subordinates = subordinates.data || []    

            this.loading = false
          })
      },
      onClickDate (day) {
        if (this.isMyProfile) {
          return 
        }

        if (!this.$hasPermissionTo(['create duty rosters'])) {
          return 
        }
        
        const date = this.$moment(day.date).format('YYYY-MM-DD')

        if (this.$moment(date).isBefore(this.$moment(), 'day')) {
          return
        }

        if (this.eventDates.includes(date)) {
          return
        }

        this.selectedDate = this.$moment(day.date).format('YYYY-MM-DD')
        
        this.showForm = true
      },
      calculateProbationDueDate (joinDate, jobBand) {
        if (this.currentNormalHireProbation) {
          return this.$moment(this.currentNormalHireProbation.end_date).format('D MMM YYYY')
        } else {
          if (jobBand) {
            if (jobBand.value < 5) {
              return this.$moment(joinDate).add(3, 'M').format('D MMM YYYY')
            } else {
              return this.$moment(joinDate).add(6, 'M').format('D MMM YYYY')
            }
          } else {
            return 'N/A' // old records have no position data
          }
        }
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.dutyRosters().create(this.employeeUid, this.prepareFormData())
              .then(res => {
                this.loadDutyRosters()
                this.$snack({ message: res.data.status })
                this.resetForm()
                this.showForm = false
              })
              .catch(e => {})
              .then(res => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return {
          work_session_shift_code_id: this.useShift ? this.selectedShift.id : null,
          start_time: this.startTime,
          end_time: this.endTime,
          is_working_day: this.startTime === this.endTime ? 0 : 1,
          date: this.selectedDate,
          remark: this.remark,
        }
      },
      editEventForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.editEventProgressing = true
            this.localEvent.work_session_shift_code_id = this.useShift ? this.selectedShift.id : null
            this.localEvent.is_working_day = this.localEvent.start_time === this.localEvent.end_time ? 0 : 1

            this.$api.dutyRosters().update(this.selectedEvent.id, this.localEvent)
              .then(res => {
                this.loadDutyRosters()
                this.$snack({ message: res.data.status })
                this.resetForm()
                
                this.showEventDialog = false
              })
              .catch(e => {})
              .then(res => {
                this.editEventProgressing = false
              })
          })
      },
      deleteEventForm () {
        this.deleteEventProgressing = true

        this.$api.dutyRosters().delete(this.selectedEvent.id)
          .then(res => {
            this.loadDutyRosters()
            this.$snack({ message: res.data.status })
            
            this.showEventDialog = false
          })
          .catch(e => {})
          .then(res => {
            this.deleteEventProgressing = false
          })
      },
      setNamesForDay () {
        let names = [
          'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday',
        ]
        this.workDays.map(function (workday, index) {
          Object.assign(workday, { name: names[index] })
        })
      },
      getEventColor (event) {
        return event.color
      },
      openEditForm (event) {
        if (this.$hasPermissionTo(['update duty rosters']) || this.$hasPermissionTo(['delete duty rosters'])) {
          this.selectedEvent = event
          this.localEvent = {
            work_session_shift_code_id: event.shiftCodeId,
            start_time: event.startTime,
            end_time: event.endTime,
            remark: event.remark,
          }

          if (event.shiftCodeId) {
            this.useShift = true
            this.selectedShift = event.shiftCodeId
          } else {
            this.useShift = false
            this.selectedShift = null
          }

          this.showEventDialog = true
        }
      },
      isEmployeeResigned (endDate) {
        return endDate !== null
      },
      isSuperiorResigned (endDate) {
        return endDate !== null && endDate <= this.$moment().format('YYYY-MM-DD')
      },
    },
  }
</script>

<style scoped>
.font-calibri{
  font-family: Calibri !important;
}

.font-16{
  font-size:16px;
}

.loading-bar >>> .v-skeleton-loader__list-item.v-skeleton-loader__bone{
  padding-left:0px;
  height:25px;
}

.label-position >>> .v-label.v-label--active{
  margin-left:-5px;
  padding: 0 2px;
  background: white;
}
</style>
